import React, { memo } from "react";

type Props = {
  type?: string;
};
const CheckIcon = memo(({ type = "default" }: Props) => {
  let com = null;
  switch (type) {
    case "default":
      com = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            d="M16.5 20.9287H7.5"
            stroke="#3A393A"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M12.75 18.9287C12.75 19.3429 12.4142 19.6787 12 19.6787C11.5858 19.6787 11.25 19.3429 11.25 18.9287H12.75ZM11.25 18.9287V16.4287H12.75V18.9287H11.25Z"
            fill="#3A393A"
          />
          <path
            d="M10.5 9.92871H13.5"
            stroke="#3A393A"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M5.5 14.9287C5.5 14.9287 3.5 13.4287 3.5 10.9287C3.5 10.1634 3.5 9.49173 3.5 8.92816C3.5 7.8236 4.39543 6.92871 5.5 6.92871V6.92871C6.60457 6.92871 7.5 7.82414 7.5 8.92871V9.92871"
            stroke="#3A393A"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M18.5 14.9287C18.5 14.9287 20.5 13.4287 20.5 10.9287C20.5 10.1634 20.5 9.49173 20.5 8.92816C20.5 7.8236 19.6046 6.92871 18.5 6.92871V6.92871C17.3954 6.92871 16.5 7.82414 16.5 8.92871V9.92871"
            stroke="#3A393A"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M16.5 11.788V7.92871C16.5 6.82414 15.6046 5.92871 14.5 5.92871H9.5C8.39543 5.92871 7.5 6.82414 7.5 7.92871V11.788C7.5 13.1254 8.16841 14.3743 9.2812 15.1162L11.4453 16.5589C11.7812 16.7828 12.2188 16.7828 12.5547 16.5589L14.7188 15.1162C15.8316 14.3743 16.5 13.1254 16.5 11.788Z"
            stroke="#3A393A"
            strokeWidth="1.5"
          />
        </svg>
      );
      break;

    default:
      com = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            d="M16.5 20.9287H7.5"
            stroke="#3A393A"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M12.75 18.9287C12.75 19.3429 12.4142 19.6787 12 19.6787C11.5858 19.6787 11.25 19.3429 11.25 18.9287H12.75ZM11.25 18.9287V16.4287H12.75V18.9287H11.25Z"
            fill="#3A393A"
          />
          <path
            d="M10.5 9.92871H13.5"
            stroke="#3A393A"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M5.5 14.9287C5.5 14.9287 3.5 13.4287 3.5 10.9287C3.5 10.1634 3.5 9.49173 3.5 8.92816C3.5 7.8236 4.39543 6.92871 5.5 6.92871V6.92871C6.60457 6.92871 7.5 7.82414 7.5 8.92871V9.92871"
            stroke="#3A393A"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M18.5 14.9287C18.5 14.9287 20.5 13.4287 20.5 10.9287C20.5 10.1634 20.5 9.49173 20.5 8.92816C20.5 7.8236 19.6046 6.92871 18.5 6.92871V6.92871C17.3954 6.92871 16.5 7.82414 16.5 8.92871V9.92871"
            stroke="#3A393A"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M16.5 11.788V7.92871C16.5 6.82414 15.6046 5.92871 14.5 5.92871H9.5C8.39543 5.92871 7.5 6.82414 7.5 7.92871V11.788C7.5 13.1254 8.16841 14.3743 9.2812 15.1162L11.4453 16.5589C11.7812 16.7828 12.2188 16.7828 12.5547 16.5589L14.7188 15.1162C15.8316 14.3743 16.5 13.1254 16.5 11.788Z"
            stroke="#3A393A"
            strokeWidth="1.5"
          />
        </svg>
      );
      break;
  }
  return <>{com}</>;
});
export default CheckIcon;
